/* eslint-disable import/no-cycle */
import { axios } from './request'
import { getAccessToken } from './auth'

export interface IUploadedPrivateFile {
	fileId: number
	fileUrl: string
}

/**
 * Upload suboru cielene obchadza existujuci POST-request helper z utils/request.ts.
 *
 * buildHeaders() v utils/request.ts vzdy nastavi 'content-type': 'application/json' (male pismena).
 * axios 0.21.4 v xhr adapteri robi `delete requestHeaders['Content-Type']` - teda presne s velkymi
 * pismenami - takze mala varianta prezije a prehliadac k FormData telu NEDOPLNI multipart boundary.
 * Bez boundary multer na serveri nenajde subor a req.file je undefined.
 *
 * Preto sa tu pouziva hola axios instancia a Content-Type sa nenastavuje vobec.
 * Existujuci GCP file uploader helper (utils/gcpFileUploader.js) sa zamerne NEUPRAVUJE - je na
 * kritickej ceste dokumentov a jeho zmena patri do samostatnej ulohy.
 */
export const uploadPrivateFile = async (file: Blob, filename: string): Promise<IUploadedPrivateFile> => {
	const formData = new FormData()
	formData.append('file', file, filename)

	const res = await axios.post('/api/admin/upload/private', formData, {
		headers: { Authorization: `Bearer ${getAccessToken()}` }
	})

	return {
		fileId: Number(res.data?.data?.fileId),
		fileUrl: res.data?.data?.fileUrl
	}
}
